import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/driver/scheduling/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 排班
export function schedulingDriver(data) {
  return request.send({
    url: `/pmy/sys/driver/scheduling`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 批量排班
export function schedulingDriverBatch(data) {
  return request.send({
    url: `/pmy/sys/driver/scheduling/batch`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// WEB--按月查询司机排班情况
export function getDriverScheduling(params) {
  return request.send({
    url: `/pmy/sys/driver/scheduling/month?driverId=${params.driverId}&month=${params.month}`,
    method: "get"
  });
}
// 获取调度组下的调度人员
export function getDispatchers() {
  return request.send({
    url: `/pmy/sys/user/dispatchers`,
    method: "get"
  });
}

// WEB--司机排班总览
export function getOverview(schedulingDate) {
  return request.send({
    url: `/pmy/sys/driver/scheduling/overview?schedulingDate=${schedulingDate}`,
    method: "get"
  });
}

// 日历排班（月度聚合）
export function getCalendarList(params) {
  return request.send({
    url: `/pmy/sys/driver/scheduling/calendar/list?month=${params.month}&companyId=${params.companyId}`,
    method: "get"
  });
}
// 日历排班（单天聚合情况-统计）
export function getCalendarOverview(params) {
  return request.send({
    url: `/pmy/sys/driver/scheduling/calendar/day/overview?day=${params.day}&companyId=${params.companyId}`,
    method: "get"
  });
}
// 日历排班（单天聚合情况-详情列表）
export function getCalendarDetail(data) {
  return request.send({
    url: `/pmy/sys/driver/scheduling/calendar/day/details`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
